export const SET_TABLE_BOOKING_APROVED_LIST = 'set-table-booking-approved-list';
export const SET_TABLE_BOOKING_PENDING_LIST = 'set-table-booking-rejected-list';
export const UPDATE_APPROVED_LIST = 'update-approved-list';
export const UPDATE_PENDING_LIST = 'update-pending-list';
